module.exports = __webpack_public_path__ + "media/lose.13b4de08.mp3";